export default __webpack_public_path__ + "static/liquidez01-3319fa5854b258634a9734f190ff52ee.svg";